import { h, Component } from 'preact';
import Store from 'store/store';
import { loadPage } from 'utils/pageComponents';
import { IntentDetector } from 'utils/intentDetector';

// Used for server-side rendering
const PLACEHOLDER_DOMAIN = 'https://placeholder/';

export default class PageLink extends Component {

	constructor(props) {
		super(props);
		this.intentDetector = new IntentDetector({
			getBaseEvent: (name) => this.props[name],
			onIntent: this.onIntent.bind(this),
		});
	}

	componentWillUnmount() {
		this.intentDetector.dispose();
	}

	onIntent() {
		loadPage(this.props.to);
	}

	getLink(page = this.props.to, query = this.props.query) {
		const [pageName, anchor] = page.split('#');
		const pageData = Store.get().appData.pages[pageName];
		if (!pageData?.path) return null;

		let base = (typeof window !== 'undefined' && window.__BASE_URL__) || PLACEHOLDER_DOMAIN;

		let url = new URL('.' + pageData.path, base);

		if (query) {
			Object.entries(query).forEach(entry => url.searchParams.set(...entry));
		}
		if (anchor) url.hash = anchor;

		return url.href.replace(PLACEHOLDER_DOMAIN, '/');
	}

	render({ to, children, ...props }) {
		return (
			<a
				href={this.getLink()}
				{...props}
				{...this.intentDetector.events}
			>
				{children}
			</a>
		);
	}

}